export const registrationStatus = {
  ChoKiemTra: "CHO_KIEM_TRA",
  HoSoHopLe: "HO_SO_HOP_LE",
  HoSoChuaHopLe: "HO_SO_CHUA_HOP_LE",
  HoSoKhongHopLe: "HO_SO_KHONG_HOP_LE",
  DaSuaVaDangChoKiemTra: "DA_SUA_VA_DANG_CHO_KIEM_TRA",
  TrungTuyen: "TRUNG_TUYEN",
  KhongTrungTuyen: "KHONG_TRUNG_TUYEN",
};
export const registrationStatusSource = [
  {
    label: "Chờ kiểm tra",
    value: registrationStatus.ChoKiemTra,
    metadata: { color: "" },
  },
  {
    label: "Hồ sơ hợp lệ",
    value: registrationStatus.HoSoHopLe,
    metadata: { color: "" },
  },
  {
    label: "Hồ sơ chưa hợp lệ",
    value: registrationStatus.HoSoChuaHopLe,
    metadata: { color: "" },
  },
  {
    label: "Hồ sơ không hợp lệ",
    value: registrationStatus.HoSoKhongHopLe,
    metadata: { color: "" },
  },
  {
    label: "Đã sửa và đang chờ kiểm tra",
    value: registrationStatus.DaSuaVaDangChoKiemTra,
    metadata: { color: "" },
  },
  {
    label: "Trúng tuyển",
    value: registrationStatus.TrungTuyen,
    metadata: { color: "" },
  },
  {
    label: "Không trúng tuyển",
    value: registrationStatus.KhongTrungTuyen,
    metadata: { color: "" },
  },
];
